import { GoogleMap, Marker, InfoWindow, Polygon } from "@react-google-maps/api";
import { useRef, useState, useEffect } from "react";
import location_pin from "../images/LeroyMerlin_icon.png";
import mainland from "../areas/mainland.json";
import sardinia from "../areas/sardinia.json";
import sicily from "../areas/sicily.json";

const Map = (props) => {
  const { isLoaded } = props;
  const mapRef = useRef(null);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [italyBoundary, setItalyBoundary] = useState([]);
  const containerStyle = {
    width: "100%",
    height: "min(800px, 100vh)",
  };
  const panToMarker = (point) => {
    setSelectedMarker(point);

    requestAnimationFrame(() => {
      if (!mapRef.current) return;

      window.google.maps.event.trigger(mapRef.current, "resize");
      mapRef.current.panTo(point.location);
      mapRef.current.panBy(0, -100);
    });
  };

  const closeInfoWindow = () => {
    const location = selectedMarker?.location;
    setSelectedMarker("");

    if (!location) return;

    requestAnimationFrame(() => {
      mapRef.current?.panTo(location);
    });
  };
  const center = {
    lat: 42.53059709637559,
    lng: 12.926756183113625,
  };

  useEffect(() => {
    const files = [mainland, sardinia, sicily];

    let allRings = [];

    files.forEach((data) => {
      data.features.forEach((feature) => {
        const geometry = feature.geometry;

        if (geometry.type === "Polygon") {
          allRings.push(
            geometry.coordinates[0].map(([lng, lat]) => ({ lat, lng })),
          );
        } else if (geometry.type === "MultiPolygon") {
          geometry.coordinates.forEach((polygon) => {
            allRings.push(polygon[0].map(([lng, lat]) => ({ lat, lng })));
          });
        }
      });
    });

    setItalyBoundary(allRings);
  }, []);

  const outerWorld = [
    { lat: 85, lng: -180 },
    { lat: 85, lng: 180 },
    { lat: -85, lng: 180 },
    { lat: -85, lng: -180 },
  ];

  const points = [
    {
      id: 316,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it21021600001004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Ancona
        </a>
      ),
      location: { lat: 43.5586968, lng: 13.5121813 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it21021600001004&product=HOURLY_RENTAL",
    },
    {
      id: 317,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it21102200001005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Assago
        </a>
      ),
      location: { lat: 45.4064331, lng: 9.15489578 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it21102200001005&product=HOURLY_RENTAL",
    },
    {
      id: 318,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18092100007009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Busnago
        </a>
      ),
      location: { lat: 45.6210365, lng: 9.47209072 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18092100007009&product=HOURLY_RENTAL",
    },
    {
      id: 319,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it22121900002004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Cagliari Elmas
        </a>
      ),
      location: { lat: 39.2738113, lng: 9.05488777 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it22121900002004&product=HOURLY_RENTAL",
    },
    {
      id: 320,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18070500005008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Caponago
        </a>
      ),
      location: { lat: 45.5699309, lng: 9.36672654 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18070500005008&product=HOURLY_RENTAL",
    },
    {
      id: 321,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18051600004000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Carugate
        </a>
      ),
      location: { lat: 45.5493928, lng: 9.32900942 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18051600004000&product=HOURLY_RENTAL",
    },
    {
      id: 322,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it22101300001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Catania
        </a>
      ),
      location: { lat: 37.445854, lng: 15.034066 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it22101300001002&product=HOURLY_RENTAL",
    },
    {
      id: 323,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18051500005001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Collegno
        </a>
      ),
      location: { lat: 45.102157, lng: 7.594996 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18051500005001&product=HOURLY_RENTAL",
    },
    {
      id: 324,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18051600002002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Corsico
        </a>
      ),
      location: { lat: 45.4310466, lng: 9.08134839 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18051600002002&product=HOURLY_RENTAL",
    },
    {
      id: 325,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18051600005009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Curno
        </a>
      ),
      location: { lat: 45.6805954, lng: 9.60397928 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18051600005009&product=HOURLY_RENTAL",
    },
    {
      id: 326,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it14120200002007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Lissone
        </a>
      ),
      location: { lat: 45.5974846, lng: 9.23416138 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it14120200002007&product=HOURLY_RENTAL",
    },
    {
      id: 327,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18040300003002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Moncalieri
        </a>
      ),
      location: { lat: 44.9749298, lng: 7.70894146 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18040300003002&product=HOURLY_RENTAL",
    },
    {
      id: 328,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18070500004009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Nova Milanese
        </a>
      ),
      location: { lat: 45.5894021, lng: 9.17511589 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18070500004009&product=HOURLY_RENTAL",
    },
    {
      id: 329,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it21110900001000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Pantigliate
        </a>
      ),
      location: { lat: 45.4296074, lng: 9.36597443 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it21110900001000&product=HOURLY_RENTAL",
    },
    {
      id: 330,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it21070500004003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Pescara
        </a>
      ),
      location: { lat: 42.419001, lng: 14.17487 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it21070500004003&product=HOURLY_RENTAL",
    },
    {
      id: 331,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18092100008008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Rimini Savignano
        </a>
      ),
      location: { lat: 44.15766, lng: 12.4337 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18092100008008&product=HOURLY_RENTAL",
    },
    {
      id: 332,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it14120200001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Roma Laurentina
        </a>
      ),
      location: { lat: 41.7950477, lng: 12.4848475 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it14120200001008&product=HOURLY_RENTAL",
    },
    {
      id: 333,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18070500003000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Rozzano
        </a>
      ),
      location: { lat: 45.3896025, lng: 9.17409515 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18070500003000&product=HOURLY_RENTAL",
    },
    {
      id: 334,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18080200002006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Seriate
        </a>
      ),
      location: { lat: 45.6701403, lng: 9.7390863 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18080200002006&product=HOURLY_RENTAL",
    },
    {
      id: 335,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it16121400005004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Torino
        </a>
      ),
      location: { lat: 45.1172342, lng: 7.713 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it16121400005004&product=HOURLY_RENTAL",
    },
    {
      id: 336,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it19012800001005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Treviso
        </a>
      ),
      location: { lat: 45.6768841, lng: 12.3335874 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it19012800001005&product=HOURLY_RENTAL",
    },
    {
      id: 337,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18051600006008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Udine
        </a>
      ),
      location: { lat: 46.085063, lng: 13.177794 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18051600006008&product=HOURLY_RENTAL",
    },
    {
      id: 338,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it15021800001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Varese Solbiate Arno
        </a>
      ),
      location: { lat: 45.7213593, lng: 8.80969524 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it15021800001002&product=HOURLY_RENTAL",
    },
    {
      id: 339,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it19011000016006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Venezia Marcon
        </a>
      ),
      location: { lat: 45.5457069, lng: 12.3025071 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it19011000016006&product=HOURLY_RENTAL",
    },
    {
      id: 340,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it19011000017005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Venezia Marghera
        </a>
      ),
      location: { lat: 45.4570045, lng: 12.21053 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it19011000017005&product=HOURLY_RENTAL",
    },
    {
      id: 341,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-it18051500004002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Leroy Merlin Verona
        </a>
      ),
      location: { lat: 45.396045, lng: 11.017645 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-it18051500004002&product=HOURLY_RENTAL",
    },
  ];

  return (
    isLoaded && (
      <>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={6}
          onLoad={(map) => {
            mapRef.current = map;
          }}
          options={{
            streetViewControl: false,
            mapTypeControl: false,
            restriction: {
              latLngBounds: { north: 47.5, south: 35.0, west: 6.0, east: 19.0 },
              strictBounds: false,
            },
            minZoom: 5,
          }}
        >
          {italyBoundary.length > 0 && (
            <Polygon
              paths={[outerWorld, ...italyBoundary]}
              options={{
                fillColor: "#414141",
                fillOpacity: 0.55,
                strokeWeight: 0,
                clickable: false,
                zIndex: 1,
              }}
            />
          )}

          {points.map((point) => {
            return (
              <div key={point.id}>
                <Marker
                  position={point.location}
                  options={{
                    icon: location_pin,
                  }}
                  onClick={() => panToMarker(point)}
                />
              </div>
            );
          })}
          {selectedMarker && (
            <InfoWindow
              position={selectedMarker.location}
              options={{
                disableAutoPan: true,
                pixelOffset: new window.google.maps.Size(0, -40),
              }}
              onCloseClick={closeInfoWindow}
            >
              <>
                <h6>{selectedMarker.name}</h6>
                <button
                  className="btn btn-warning"
                  onClick={() => (window.location.href = selectedMarker.ufoUrl)}
                >
                  Prenota ora
                </button>
              </>
            </InfoWindow>
          )}
        </GoogleMap>
      </>
    )
  );
};

export default Map;
